import React, { useState, useEffect } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { submitContactForm } from "../../api/authApi";
import { useUser } from "../../context/UserContext";

const inputStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "10px",
  border: "1px solid #e5e7eb",
  outline: "none",
  transition: "0.3s",
};

const Contact = () => {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { company, loading: companyLoading } = useUser();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNo: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrorMsg("");
    setResponseMsg("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg("");
    setErrorMsg("");

    try {
      const res = await submitContactForm(formData);
      setResponseMsg(res.message || "Message sent successfully!");
      setFormData({ name: "", email: "", phoneNo: "", message: "" });
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    } catch (err) {
      setErrorMsg(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="row g-4">

        {/* LEFT SIDE */}
        <div className="col-lg-5">
          <div
            style={{
              background: "#0f172a",
              color: "#fff",
              padding: "30px",
              borderRadius: "16px",
              height: "100%",
            }}
          >
            <h3 style={{ fontWeight: "bold", marginBottom: "20px" }}>
              Get in Touch
            </h3>

            {companyLoading ? (
              <p>Loading company details...</p>
            ) : (
              <>
                {/* LOCATION */}
                <div style={{ display: "flex", gap: "15px", marginBottom: "25px" }}>
                  <div
                    style={{
                      width: isMobile ? "187px" : "100px",
                      height: "45px",
                      borderRadius: "12px",
                      background: "#0d6efd",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                    }}
                  >
                    <FaMapMarkerAlt />
                  </div>
                  <div>
                    <h6>Location</h6>
                    <p style={{ margin: 0, opacity: 0.8 }}>
                      {company?.address || "—"}
                    </p>
                  </div>
                </div>

                <div style={{ display: "flex", gap: "15px", marginBottom: "25px" }}>
                  <div
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "12px",
                      background: "#f59e0b",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                    }}
                  >
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <h6>Phone</h6>
                    <p style={{ margin: 0, opacity: 0.8 }}>
                      {company?.contact_phone || "—"}
                    </p>
                  </div>
                </div>

                {/* EMAIL */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <div
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "12px",
                      background: "#f59e0b",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                    }}
                  >
                    <FaEnvelope />
                  </div>
                  <div>
                    <h6>Email</h6>
                    <p style={{ margin: 0, opacity: 0.8 }}>
                      {company?.contact_email || "—"}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-lg-7">
          <div
            style={{
              background: "#fff",
              padding: "30px",
              borderRadius: "16px",
              boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
            }}
          >
            <h2 style={{ fontWeight: "bold", marginBottom: "5px" }}>
              Send Message
            </h2>
            <p style={{ color: "#6b7280", marginBottom: "20px" }}>
              We’ll get back to you as soon as possible.
            </p>

            {responseMsg && (
              <div className="alert alert-success">{responseMsg}</div>
            )}
            {errorMsg && (
              <div className="alert alert-danger">{errorMsg}</div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="row g-3">

                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                </div>

                <div className="col-md-6">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                </div>

                <div className="col-12">
                  <input
                    type="tel"
                    name="phoneNo"
                    placeholder="Phone Number"
                    value={formData.phoneNo}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                </div>

                <div className="col-12">
                  <textarea
                    name="message"
                    rows="5"
                    placeholder="Write your message..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                </div>

                <div className="col-12">
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      width: "100%",
                      padding: "12px",
                      border: "none",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #0d6efd, #2563eb)",
                      color: "#fff",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "0.3s",
                    }}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </div>

              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Contact;
